import { render, staticRenderFns } from "./ShopRankTable.vue?vue&type=template&id=c9006bf0"
import script from "./ShopRankTable.vue?vue&type=script&lang=js"
export * from "./ShopRankTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9006bf0')) {
      api.createRecord('c9006bf0', component.options)
    } else {
      api.reload('c9006bf0', component.options)
    }
    module.hot.accept("./ShopRankTable.vue?vue&type=template&id=c9006bf0", function () {
      api.rerender('c9006bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/ShopRankTable.vue"
export default component.exports